const ActionTypes = {
  SET_ALERT_LIST: 'SET_ALERT_LIST',
  ADD_ALERT: 'ADD_ALERT',
  DELETE_ALERT: 'DELETE_ALERT',
  DUPLICATE_ALERT: 'DUPLICATE_ALERT',
  SET_ALERT_RULES_LIST: 'SET_ALERT_RULES_LIST',
  GET_LIST_ALERT_EVENTS: 'GET_LIST_ALERT_EVENTS',
  SET_RULES_METRICS_LIST: 'SET_RULES_METRICS_LIST',
  ADD_RULE: 'ADD_RULE',
  DELETE_ALERT_RULES: 'DELETE_ALERT_RULES',
  DUPLICATE_RULE: 'DUPLICATE_RULE',
  EDIT_RULE: 'EDIT_RULE'
};

export default ActionTypes;
